import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';

import AngeboteListView from './sites/l_angebote';
import AngebotDetailView from './sites/d_angebot';

// FontAwesome 
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaw, faSmoking, faBabyCarriage, faWheelchair, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

import './App.css';
import GesucheListView from './sites/l_gesuche';
import GesuchDetailView from './sites/d_gesuche';
import Inserieren from './sites/inserieren';
import EntfernenView from './sites/entfernen';

library.add(faPaw, faSmoking, faBabyCarriage, faWheelchair, faPlus, faMinus);

class App extends Component {
  render() {
    return <HashRouter>
        <div>
          <Route path="/" component={AngeboteListView} exact />
          <Route path="/gesuche" component={GesucheListView} />
          <Route path="/angebot/:id" component={AngebotDetailView} />
          <Route path="/gesuch/:id" component={GesuchDetailView} />
          <Route path="/inserieren" component={Inserieren} />
          <Route path="/entfernen/:id" component={EntfernenView} />
        </div>
      </HashRouter>;
  }
}

export default App;
